import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  addLeaveConfiguration,
  addLeaveTypes,
  getAllLeaveBalance,
  getAllLeaveConfiguration,
  getAllLeaveRequestsData,
  getAllLeaveStatus,
  getAllLeaveViewStatus,
  getLeaveType,
  getLeaveViewData,
  getPolicyYear,
  updateLeaveConfiguration,
  updateLeaveRequests,
  updateLeaveStatus,
  updateLeaveType,
} from "./LeaveRepository";
// import { toast } from "react-toastify";
import { showToast } from "../../../utils/toastUtils";

export const useLeaveTypesData = ({
  params = {},
  enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["LEAVE_TYPES"],
    queryFn: getLeaveType,
    enabled: enable,
    retry: false,
  });
};

export const useAddLeaveTypes = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addLeaveTypes,
    onSuccess: (data: any) => {
      showToast.success(data?.data?.message);
      queryClient.invalidateQueries({ queryKey: ["LEAVE_TYPES"] });
    },
    onError: (error: any) => {
      console.log("Failed to Add Leave Type!", error?.response?.data?.message);
    },
  });
};

export const useUpdateLeaveType = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: any }) =>
      updateLeaveType(id, body),
    onSuccess: (data: any) => {
      showToast.success(data?.data?.message);
      queryClient.invalidateQueries({ queryKey: ["LEAVE_TYPES"] });
    },
    onError: (error: any) => {
      console.log(
        "🚀 ~ useLeave.tsx:62 ~ useUpdateLeaveType ~ error:",
        error?.response?.data?.message
      );
    },
  });
};

export const useLeaveConfigurationData = ({
  params = {},
  enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["LEAVE_CONFIGURATION", params],
    queryFn: () => getAllLeaveConfiguration(params),
    enabled: enable,
    retry: false,
  });
};

export const useAddLeaveConfiguration = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addLeaveConfiguration,
    onSuccess: (data: any) => {
      showToast.success(data?.data?.message);
      queryClient.invalidateQueries({ queryKey: ["LEAVE_CONFIGURATION"] });
    },
    onError: (error: any) => {
      console.log(
        "🚀 ~ useLeave.tsx:91 ~ useAddLeaveConfiguration ~ error:",
        error?.response?.data?.message
      );
    },
  });
};

export const useUpdateLeaveConfiguration = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: any }) =>
      updateLeaveConfiguration(id, body),
    onSuccess: (data: any) => {
      showToast.success(data?.data?.message);
      queryClient.invalidateQueries({ queryKey: ["LEAVE_CONFIGURATION"] });
    },
    onError: (error: any) => {
      console.log(
        "🚀 ~ useLeave.tsx:110 ~ useUpdateLeaveConfiguration ~ error:",
        error?.response?.data?.message
      );
    },
  });
};

export const useLeaveRequestsData = ({
  params = {},
  enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["LEAVE_REQUEST", params],
    queryFn: () => getAllLeaveRequestsData(params),
    enabled: enable,
    retry: false,
  });
};

export const useLeaveViewData = ({
  id,
  params = {},
  enable = false,
}: { id?: any; params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["LEAVE_REQUEST", id, params],
    queryFn: () => getLeaveViewData(id, params),
    enabled: enable,
    retry: false,
  });
};

export const useUpdateStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: any) => updateLeaveStatus(body),
    onSuccess: (data: any) => {
      showToast.success(data?.data?.message);
      queryClient.invalidateQueries({ queryKey: ["LEAVE_REQUEST"] });
    },
    onError: (error: any) => {
      console.log(
        "🚀 ~ useLeave.tsx:153 ~ useUpdateStatus ~ error:",
        error?.response?.data?.message
      );
    },
  });
};

export const useUpdateLeaveRequests = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: any }) =>
      updateLeaveRequests(id, body),
    onSuccess: (data: any) => {
      showToast.success(data?.data?.message);
      queryClient.invalidateQueries({ queryKey: ["LEAVE_REQUEST"] });
    },
    onError: (error: any) => {
      console.log(
        "🚀 ~ useLeave.tsx:162 ~ useUpdateLeaveRequests ~ error:",
        error?.response?.data?.message
      );
    },
  });
};

export const useLeaveViewStatus = ({
  params = {},
  enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["LEAVE_REQUEST_STATUS"],
    queryFn: getAllLeaveViewStatus,
    enabled: enable,
    retry: false,
  });
};

export const useLeaveStatus = ({
  params = {},
  enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["LEAVE_VIEW_STATUS"],
    queryFn: getAllLeaveStatus,
    enabled: enable,
    retry: false,
  });
};

// getAllLeaveBalance
export const useLeaveBalanceData = ({
  params = {},
  enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["LEAVE_BALANCE", params],
    queryFn: () => getAllLeaveBalance(params),
    enabled: enable,
    retry: false,
  });
};

export const usePolicyYear = ({
  enable = false,
}: { enable?: boolean } = {}) => {
  return useQuery({
    queryKey: ["LEAVE_POLICY_YEAR"],
    queryFn: getPolicyYear,
    enabled: enable,
    retry: false,
  });
};
